// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Zvc5","textarea":"styles_textarea__1hQJS"};